module.exports = __webpack_public_path__ + "img/4_23.348689b1.png";